var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-col',{staticClass:"d-flex justify-center"},[_c('v-progress-circular',{attrs:{"size":"140","color":"white","indeterminate":""}},[_vm._v(" "+_vm._s(_vm.loadingText)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }